import { Component, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastService } from 'src/app/services/toast.service';
import { AccountService } from 'src/app/services/account.service';
import { AuthService } from 'src/app/services/auth.service';

export interface MfaDialogData {
    username: string;
    isLogin: boolean;
}

@Component({
  standalone: false,
    selector: 'app-mfa-dialog-component',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './mfaDialog.component.html',
})
export class MfaDialogComponent implements OnDestroy {

    isLoading = false;
    otp: string;

    constructor(public dialogRef: MatDialogRef<MfaDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MfaDialogData,
        private accountService: AccountService,
        private authService: AuthService,
        private toastService: ToastService) {
    }

    ngOnDestroy() {
    }

    ok() {
        this.isLoading = true;
        const request = this.data.isLogin
            ? this.authService.verifyOtp(this.data.username, this.otp)
            : this.accountService.verifyOtp(this.otp);
        
        request.subscribe(response =>
            {
                this.isLoading = false;
                this.toastService.showSuccess('OTP Code verified successfully', true);
                this.dialogRef.close(true);
            }, error => {
                this.isLoading = false;
                this.toastService.showError(error);
            });
    }
}
